import React from 'react';
import { AlertZoneIcon } from '../../styled';
import { TbAlertTriangleFilled } from 'react-icons/tb';

const AlertAgentTag = ({ statusOfChat }) => {
  if (statusOfChat !== 'AgentWarning' && statusOfChat !== 'AgentCritical') {
    return <> </>;
  }

  return (
    <AlertZoneIcon type={statusOfChat}>
      <TbAlertTriangleFilled size="12" color="#fff" />
    </AlertZoneIcon>
  );
};

export default AlertAgentTag;
